module.exports = __webpack_public_path__ + "img/positiveEffects@2x.e99e660.webp";